export default __webpack_public_path__ + "static/media/Brigand's Armbands of the Bloody Fang.28da852f.jpg";